import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    brand: {
      type: Array,
      default: function _default() {
        return new Array();
      }
    }
  },
  watch: {
    brand: {
      deep: true,
      immediate: true,
      handler: function handler(param) {
        this.brandList = param;
      }
    }
  },
  data: function data() {
    return {
      pageLoading: false,
      brandList: [{
        text: null
      }]
    };
  },
  methods: {
    updateProductBrand: function updateProductBrand() {
      var _this = this;

      _this.pageLoading = true;

      _this.$store.dispatch(PATCH, {
        url: "setting/product-brand",
        data: {
          product_brand: _this.brandList
        }
      }).then(function () {
        _this.$emit("close-dialog", true);

        _this.$emit("get-product-brand", true);
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    createProductBrand: function createProductBrand() {
      this.brandList.push({
        text: null
      });
    },
    deleteProductBrand: function deleteProductBrand(index) {
      if (this.brandList.length > 1) {
        this.brandList.splice(index, 1);
      }
    }
  },
  components: {
    Dialog: Dialog
  },
  computed: {
    dialogWidth: function dialogWidth() {
      return this.lodash.toSafeInteger(document.body.clientWidth / 100 * 50);
    }
  }
};